import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MontoRecibidoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='RECIBIDO' htmlFor='input-montoRecibido' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='montoRecibido'>
          {({ field }) => <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-montoRecibido' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoRecibidoFormGroup)
